import {
  GET_CATALOG_RECORDS,
  GET_CATALOG_SUCCESS,
  GET_CATALOG_ERROR,
  TOGGLE_CART_RECORDS,
  TOGGLE_CART_RECORD_SUCCESS,
  TOGGLE_CART_RECORD_ERROR,
  TOGGLE_REMOVE_CART_RECORDS,
  GET_CATALOG_SINGLE_RECORD,
  GET_CATALOG_SINGLE_SUCCESS,
  GET_CATALOG_SINGLE_ERROR,
  SHOW_CART_RECORDS,

} from "../actions";

export const getRecord = (catalogItemId) => {
  return {
    type: GET_CATALOG_SINGLE_RECORD,
    payload: { catalogItemId },
  };
};

export const getRecordSuccess = (recordList) => ({
  type: GET_CATALOG_SINGLE_SUCCESS,
  payload: recordList,
});

export const getRecordError = (message) => ({
  type: GET_CATALOG_SINGLE_ERROR,
  payload: { message },
});

export const getRecords = (pageNumber, searchText, termIds, vocabularyId, activityInfo) => {
  return {
    type: GET_CATALOG_RECORDS,
    payload: { pageNumber, searchText, termIds, vocabularyId, activityInfo },
  };
};

export const getRecordsSuccess = (recordList) => ({
  type: GET_CATALOG_SUCCESS,
  payload: recordList,
});

export const getRecordsError = (message) => ({
  type: GET_CATALOG_ERROR,
  payload: { message },
});

export const toggleCart = (catalog, showHideCartPanel, orderId, activityInfo) => {

  return {
    type: TOGGLE_CART_RECORDS,
    payload: { catalog, showHideCartPanel, orderId, activityInfo },
  };
};

export const getToggleCartSuccess = (recordItemReturned) => ({
  type: TOGGLE_CART_RECORD_SUCCESS,
  payload: { lineItemAdded: recordItemReturned.lineItemAdded, orderId: recordItemReturned.orderId },
});

export const getToggleCartError = (message) => ({
  type: TOGGLE_CART_RECORD_ERROR,
  payload: { message },
});

export const showCart = (showHideCartPanel) => {

  return {
    type: SHOW_CART_RECORDS,
    payload: { showHideCartPanel },
  };
};




export const removeItem = (catalogId) => {

  return {
    type: TOGGLE_REMOVE_CART_RECORDS,
    payload: { catalogId },
  };
};
